export default __webpack_public_path__ + "static/media/collaborateur.88eadb9f.svg";